<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="name" slot-scope="name">
          <div>
            <div class="font-weight-bold">{{name}}</div>
          </div>
        </template>
        <template slot="description" slot-scope="description">
          <div>
            <div class="font-weight-bold">{{description}}</div>
          </div>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- Edit -->
            <a href="javascript:;" class="btn btn-sm btn-light btn-with-addon mr-2"
              @click="showEditModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
              <!-- <edit-school-class ref="editClass" @edited="handleEdited" /> -->
              Edit
            </a>
            <a-tooltip placement="top">
              <span>
                <!-- Delete -->
                <a href="javascript:;" class="btn btn-sm btn-danger btn-with-addon"
                  @click="onDelete(record)"
                >
                  <span class="btn-addon">
                    <i class="btn-addon-icon fe fe-trash" />
                  </span>
                  Delete
                </a>
              </span>
            </a-tooltip>
          </div>
        </template>
      </a-table>
    </div>

    <edit-school-class ref="editClass" @edited="handleEdited" />
  </div>
</template>
<script>
import moment from 'moment'
import EditSchoolClass from '@/components/subject-group/Forms/Edit/index'

const columns = [
  {
    title: 'Class name',
    className: 'text-left',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' },
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: 'Description',
    className: 'text-left text-gray-6',
    dataIndex: 'description',
    scopedSlots: { customRender: 'description' },
    // sorter: (a, b) => a.name.length - b.name.length,
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]

export default {

  name: 'SchoolClassesTable',
  components: {
    EditSchoolClass,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      columns,
      selectedRowKeys: [],
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showEditModal: function(record) {
      // this.$refs.editClass.showModal(record.id)
      this.$eventBus.$emit('openSubjectGroupEditModal', record.id)
    },
    handleEdited: function () {
      this.$emit('updateTable')
    },
    handleDate: function($date) {
      return moment($date).format('DD-MM-YYYY')
    },
    onDelete: function(record) {
      this.$confirm({
        title: 'Are you sure delete this subject group?',
        content: 'Some descriptions',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/subject-group/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: record.name + ' has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
